const numberToArr = (n: number): number[] => "".padStart(n).split("").map((_, i) => i)

export default numberToArr